<template>
    <div>

        <div class="row">
            <div class="col">
                <h3>
                    Filtres
                </h3>
                <v-select label="Tag" outlined chips @input="setSelectedTags" :value="selectedTags" :items="tags"
                          no-data-text="Aucun tag n'a encore été créé" small-chips deletable-chips item-value="id"
                          item-text="name" multiple :disabled="tags.length === 0  || loadingApidaeProviders">
                </v-select>

                <v-select label="Catégorie" outlined chips small-chips deletable-chips :items="categories"
                          @input="setSelectedCategories" :value="selectedCategories" item-value="id" item-text="label"
                          multiple :disabled="categories.length === 0 || loadingApidaeProviders">
                </v-select>

                <v-select :label="cityWording" outlined chips small-chips deletable-chips :items="communes"
                          @input="setSelectedCommunes" :value="selectedCommunes" item-value="id" item-text="label"
                          multiple
                          :disabled="communes.length === 0 || loadingApidaeProviders">
                </v-select>

                <v-select label="Secteur touristique" outlined chips small-chips deletable-chips :items="tourismSectors"
                          @input="setSelectedTourismSectors" :value="selectedTourismSectors" item-value="id"
                          item-text="label" multiple
                          :disabled="tourismSectors.length === 0 || loadingApidaeProviders"
                          v-if="this.account.tis_type.code === 'DAHUB_QUEBEC'">
                </v-select>

                <div class="d-flex justify-content-center"
                     v-if="account.tis_type.code === 'APIDAE'">
                    <strong class="text-primary my-4">ou</strong>
                </div>

                <v-select label="Sélection Apidae" outlined v-if="account.tis_type.code === 'APIDAE'"
                          :items="apidaeSelections" @input="setSelectedApidaeSelection" :value="selectedApidaeSelection"
                          return-object item-text="libelle.libelleFr"
                          :disabled="apidaeSelections.length == 0 || loadingApidaeProviders">
                </v-select>
            </div>
            <div class="col-12 col-lg-8">
                <h3>
                    Prestataires
                    <div class="badge blue-grey darken-2 text-white">
                        <span v-if="!loadingApidaeProviders">{{ filteredProviders.length }}</span>
                    </div>
                </h3>

                <v-simple-table v-if="!loadingApidaeProviders" fixed-header class="border mt-5" height="50vh">
                    <thead>
                    <tr>
                        <th class="text-left">Nom</th>
                        <th class="text-left">Catégorie</th>
                        <th class="text-left">{{ cityWording }}</th>
                        <th class="text-left">Destinataire</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="provider in filteredProviders" :key="provider.id">
                        <td>{{ provider.name }}</td>
                        <td>{{ provider.category }}</td>
                        <td>{{ provider.commune }}</td>
                        <td>{{ provider.email }}</td>
                    </tr>
                    </tbody>
                </v-simple-table>
                <div v-else class="d-flex justify-content-center p-3">
                    <v-progress-circular class="progressbar mr-2" indeterminate size="40" width="4">
                    </v-progress-circular>
                </div>
            </div>
        </div>

        <div class="text-right mb-5 mt-5">
            <v-btn class="default-button" @click="setAddProStep(2)">Passer à l'étape suivante</v-btn>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import * as EmailValidator from "email-validator"

export default {
    name: "VtcFilters",
    data() {
        return {
            loadingCommunes: false,
            searchCommunes: null,
            panel: [],
            loadingApidaeProviders: true,
            lockSearch: false,
            cityWording: "Commune",
        }
    },
    methods: {
        ...mapMutations("vtc", [
            "setSelectedCategories",
            "setSelectedCommunes",
            "setSelectedTags",
            "setFilteredProviders",
            "setAddProStep",
            "setSelectedApidaeSelection",
            "setSelectedTourismSectors",
            "setAlreadyInVtc",
            "setNotAlreadyInVtc",
            "setProvidersToAdd",
            'setSelectedProviders',
        ]),
        getProviders() {
            this.loadingApidaeProviders = true

            let payload = {
                categoryIds: this.selectedCategories,
                communeIds: this.selectedCommunes,
                tagIds: this.selectedTags,
                tourismSectors: this.selectedTourismSectors,
            }
            this.$http.post("auth/campaigns/providers", payload).then(res => {
                let providersList = JSON.parse(JSON.stringify(res.body.data.providers))
                this.setFilteredProviders(res.body.data.providers)
                this.excludeProvidersAlreadyInVtc(providersList)

                this.$global.$emit("reload-info")

                this.loadingApidaeProviders = false
            })
        },
        getApidaeProviders() {
            if (this.selectedApidaeSelection !== null) {
                this.loadingApidaeProviders = true

                let payload = {
                    projectId: this.selectedApidaeSelection.projectId,
                    selectionId: this.selectedApidaeSelection.id,
                    selectionName: this.selectedApidaeSelection.nom,
                    disabled: ["DOMAINE_SKIABLE", "STRUCTURE"],
                }

                this.$http.post("auth/account/apidae-selections/providers", payload).then(res => {
                    this.setFilteredProviders(res.body.data.providers)
                    let providersList = JSON.parse(JSON.stringify(res.body.data.providers))
                    this.excludeApidaeProvidersAlreadyInVtc(providersList)

                    this.loadingApidaeProviders = false
                    this.$global.$emit("reload-info")
                })
            }
        },
        excludeProvidersAlreadyInVtc(providers) {
            let excludedProviders = []
            let addableProviders = []

            if(this.vtc.providers) {
                providers.forEach((provider) => {
                    if (this.vtc.providers.find(pro => {
                        return pro.id === provider.id
                    })) {
                        excludedProviders.push(provider)
                    } else {
                        addableProviders.push(provider)
                    }
                })
            } else {
                addableProviders = providers
            }


            this.setNotAlreadyInVtc(addableProviders)
            this.setAlreadyInVtc(excludedProviders)
        },
        excludeApidaeProvidersAlreadyInVtc(providers) {
            let excludedProviders = []
            let addableProviders = []

            if(this.vtc.providers) {
                providers.forEach((provider) => {
                    if (this.vtc.providers.find(pro => {
                        return parseInt(pro.apidae_id) === provider.external_id //comparaison string avec int
                    })) {
                        excludedProviders.push(provider)
                    } else {
                        addableProviders.push(provider)
                    }
                })
            } else {
                addableProviders = providers
            }

            this.setNotAlreadyInVtc(addableProviders)
            this.setAlreadyInVtc(excludedProviders)
        },
        resetVtcProvidersLists() {
            this.setNotAlreadyInVtc([])
            this.setAlreadyInVtc([])
            this.setProvidersToAdd([])
            this.setSelectedProviders([])
        },
    },
    computed: {
        ...mapState("account", [
            "tags",
            "categories",
            "communes",
            "account",
            "apidaeSelections",
            "tourismSectors",
        ]),
        ...mapState("vtc", [
            "selectedCategories",
            "selectedCommunes",
            "selectedTags",
            "filteredProviders",
            "selectedApidaeSelection",
            "selectedTourismSectors",
            "vtc",
        ]),
    },
    watch: {
        selectedCategories() {
            if (!this.lockSearch) {
                this.resetVtcProvidersLists()
                this.getProviders()
            }

            if (this.selectedCategories.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedCommunes() {
            if (!this.lockSearch) {
                this.resetVtcProvidersLists()
                this.getProviders()
            }

            if (this.selectedCommunes.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedTags() {
            if (!this.lockSearch) {
                this.resetVtcProvidersLists()
                this.getProviders()
            }

            if (this.selectedTags.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedTourismSectors() {
            if (!this.lockSearch) {
                this.resetVtcProvidersLists()
                this.getProviders()
            }

            if (this.selectedTourismSectors.length) {
                this.setSelectedApidaeSelection(null)
            }
        },
        selectedApidaeSelection() {
            this.resetVtcProvidersLists()
            this.getApidaeProviders()

            this.lockSearch = true

            if (this.selectedApidaeSelection !== null) {
                this.setSelectedCommunes([])
                this.setSelectedCategories([])
                this.setSelectedTags([])
                this.setSelectedTourismSectors([])
            }

            setTimeout(() => {
                this.lockSearch = false
            }, 500)
        },
    },
    created() {
        this.$store.dispatch("resource/fetchCategories")
        this.$store.dispatch("account/fetchTags")
        this.$store.dispatch("account/fetchApidaeSelections")

        if (this.selectedApidaeSelection) {
            this.getApidaeProviders()
        } else {
            this.getProviders()
        }

        if (this.account.configurations.quebec) {
            this.cityWording = "Municipalité"
        }
    },
}
</script>